/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBoilerHotWaterGasAndOil: {
  name: 'boiler-hot-water-gas-and-oil';
  data: string;
} = {
  name: 'boiler-hot-water-gas-and-oil',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H3Zm0 2h18v12H3V4Zm12 4a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-2Zm0 2h2v2h-2v-2ZM1 21a1 1 0 0 1 1-1h20a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1Zm6-10a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0v-2Zm0-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
